'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectThread = undefined;

var _reduxActions = require('redux-actions');

var _selectedThreadActionTypes = require('../constants/selectedThreadActionTypes');

var selectThread = exports.selectThread = (0, _reduxActions.createAction)(_selectedThreadActionTypes.SELECT_THREAD, function (threadId) {
  return {
    threadId: threadId
  };
});